// components/FloatingDateBar/FloatingDateBar.jsx
import React, {useState,useRef} from 'react';
import { es } from 'date-fns/locale';
import { format, subDays, addDays, isSameDay } from 'date-fns';
import { Menu } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../styles/FloatingDateBar.css';
import DatePicker from 'react-datepicker';

const FloatingDateBar = ({ currentDate, onDateChange, loading,onToggleSidebar }) => {
    const [isOpen, setIsOpen] = useState(false);
    const datePickerRef = useRef(null);

    const handlePrevDay = () => {
        onDateChange(prev => subDays(prev, 1));
    };

    const handleNextDay = () => {
        onDateChange(prev => addDays(prev, 1));
    };

    const handleDateChange = (date) => {
        onDateChange(date);
        setIsOpen(false);
    };

    const toggleCalendar = () => {
        setIsOpen(!isOpen);
    };

    const isToday = isSameDay(currentDate, new Date());

  return (
    <div className="floating-date-bar">
        <button
            className="sidebar-btn"
            onClick={onToggleSidebar} // ← Usa la función pasada por props
            aria-label="Abrir menú"
        >
            <Menu size={20} /> {/* Icono de hamburguesa */}
        </button>
        <div className="date-navigator">
            <button
                className="nav-btn"
                onClick={handlePrevDay}
                disabled={loading}
                aria-label="Día anterior"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <DatePicker
                selected={currentDate}
                onChange={handleDateChange}
                locale={es}
                dateFormat="dd/MM/yyyy"
                open={isOpen}
                onClickOutside={() => setIsOpen(false)}
                popperClassName="floating-date-picker"
                calendarClassName="glass-calendar"
                popperPlacement="bottom"
                showPopperArrow={false}
                customInput={<div style={{ display: 'none' }} />} // Input oculto
                ref={datePickerRef}
            />
            <div className="date-display clickable" onClick={toggleCalendar}>
                <span className="date-label">
                    {isToday ? 'Hoy' : format(currentDate, 'EEEE',{locale: es})}
                </span>
                <span className="date-value">
                    {format(currentDate, 'dd MMM yyyy', { locale: es })}
                </span>
            </div>

            <button
                className="nav-btn"
                onClick={handleNextDay}
                disabled={isToday || loading}
                aria-label="Día siguiente"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>
      
      {loading && <div className="loading-indicator" />}
    </div>
  );
};

export default FloatingDateBar;